import React, { PureComponent } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import styled from "styled-components";

export const MessageBoardSearchFormWrapper = styled.section`
  .form-label {
    font-size: 13px;
    margin-bottom: 3px;
  }
  .form-control {
    width: 70%;
    display: inline;
    margin-right: 16px;
  }
  .btn {
    font-size: 12px;
  }
`;

class MessageBoardSearchForm extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      terms: "",
    };
  }

  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    const searchTerms = form.terms.value.trim();
    if (searchTerms) {
      this.props.doSearch(searchTerms);
    }
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }
    return (
      <MessageBoardSearchFormWrapper>
        <Form className="mb-search-form" noValidate onSubmit={(e) => this.handleSubmit(e)}>
          <Form.Group controlId="terms">
            <Form.Label>Search the Message Board</Form.Label>
            <Form.Control type="text" autoComplete="off" />
            <Button variant="primary" type="submit">
              Search
            </Button>
          </Form.Group>
        </Form>
      </MessageBoardSearchFormWrapper>
    );
  }
}

MessageBoardSearchForm.propTypes = {
  // bla: PropTypes.string,
};

MessageBoardSearchForm.defaultProps = {
  // bla: 'test',
};

export default MessageBoardSearchForm;
